const MAIN_DOMAIN = 'eduwally.kz'
// const MAIN_DOMAIN = '91.147.92.59'
const MAIN_DOMAIN_LINK = `https://${MAIN_DOMAIN}`

export const REQUEST_URL = `${MAIN_DOMAIN_LINK}/resource`
// export const REQUEST_URL = 'http://localhost:8085'

export const LoggerURL = `${MAIN_DOMAIN_LINK}/logger`
export const AuthorizationLogger = '~Kpe@imrcdtT2m~|zOmto%nw1$8j4N5zS?WXU8@6ZZ~R2Tg7oQ'
export const STORAGE_DOMAIN = MAIN_DOMAIN



// WEBPACK FOOTER //
// ./src/_config.js